export default "__VITE_ASSET__Bbvef_xi__"